"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Screen_1 = __importDefault(require("./Screen"));
const ui_1 = require("@rahtab/ui");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Background = (props) => {
    const { children, image } = props;
    if (image)
        return react_1.default.createElement(react_native_1.ImageBackground, { style: styles.background, source: image, children: children });
    return react_1.default.createElement(react_native_1.View, { style: styles.background, children: children });
};
const logo = require('../../assets/images/logo-white-no-link.png');
const LandingScreen = (props) => {
    const { backgroundImage, title, children, ...screenProps } = props;
    return (react_1.default.createElement(Screen_1.default, Object.assign({}, screenProps, { headerShown: false, renderMain: () => {
            return (react_1.default.createElement(Background, { image: backgroundImage },
                react_1.default.createElement(react_native_1.StatusBar, { barStyle: "light-content", backgroundColor: "rgba(0,0,0,0)", translucent: true }),
                react_1.default.createElement(react_native_1.Image, { style: styles.logo, source: logo, resizeMode: "contain" }),
                react_1.default.createElement(react_native_1.View, { style: styles.container },
                    react_1.default.createElement(ui_1.Text, { style: styles.title, variant: "title", margin: "none", children: title }),
                    children)));
        } })));
};
exports.default = LandingScreen;
const styles = react_native_1.StyleSheet.create({
    background: {
        ...react_native_1.StyleSheet.absoluteFillObject,
        backgroundColor: ui_1.Colors.primary,
    },
    logo: {
        alignSelf: 'center',
        flex: 1,
        marginTop: react_native_1.StatusBar.currentHeight,
        width: 157.5,
    },
    container: {
        backgroundColor: ui_1.Colors.white,
        borderTopEndRadius: ui_1.getRadius(),
        borderTopStartRadius: ui_1.getRadius(),
        padding: ui_1.getSpacing(2),
    },
    title: {
        alignSelf: 'center',
        marginBottom: ui_1.getSpacing(2),
    },
});
